import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IPaginatedListResponse } from '@/api/types';
import { ApiVersion } from '@/config';
import { IInmate, IInmateNote } from '@/pages/JMS/Managament/types/inmate';
import { InmateMovementSubmitData } from '@/pages/JMS/Operations/InmatesMovement/types';

export const InmateApi = {
  updateIdentity: async (
    data: Pick<IInmate, 'masterName'>,
    id?: string,
  ): Promise<AxiosResponse<IInmate>> => {
    return http.patch(`api/${ApiVersion.V1}/inmates/${id}/identity`, data);
  },
  list: async (
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IInmate>>> => {
    return http.get(`api/${ApiVersion.V1}/inmates`, { params });
  },
  moveInmates: async (
    data: InmateMovementSubmitData,
  ): Promise<AxiosResponse<void>> => {
    return http.post(`api/${ApiVersion.V1}/inmates/movement`, data);
  },
  listByLocation: async (
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IInmate>>> => {
    return http.get(`api/${ApiVersion.V1}/inmates/location`, { params });
  },
  get: async (inmateId?: string): Promise<AxiosResponse<IInmate>> => {
    return http.get(`api/${ApiVersion.V1}/inmates/${inmateId}`);
  },
  createNote: async (
    data: IInmateNote,
    inmateId?: string,
  ): Promise<AxiosResponse<IPaginatedListResponse<IInmateNote>>> => {
    return http.post(`api/${ApiVersion.V1}/inmate-notes/${inmateId}`, data);
  },
  noteList: async (
    params: IGetParams,
    inmateId?: string,
  ): Promise<AxiosResponse<IPaginatedListResponse<IInmateNote>>> => {
    return http.get(`api/${ApiVersion.V1}/inmate-notes/${inmateId}`, {
      params,
    });
  },
};
